import React from "react";
import { useNavigate } from "react-router-dom";
import TicketReturnEditor from "../Common/TicketReturnEditor";
import { CUSTOMER_RETURNS_PAGE } from "../../routes/routeConstants";

export default function CustomerReturnForm({ customerReturn, onClose }) {
    const navigate = useNavigate();
    return <TicketReturnEditor key={customerReturn?.id || 'new'} customerReturn={customerReturn}
        onClose={onClose || (() => navigate(CUSTOMER_RETURNS_PAGE))} />;
}
